<template>
    <div :class="'product-card-inner' + (product.clearancePrice ? ' clearance' : '')" :data-sku="product.sku" :data-label="product.tag ? product.tag.name : product.clearancePrice && !isPromoted ? __('vue.product-pricing.clearance') : (product.clearancePrice && isPromoted ? __('vue.product-pricing.star-offer'): null)">
        <div class="product-basket-count" v-bind:class="{ 'product-basket-count-lower': !activeList && product.tag || product.clearancePrice  }" v-if="productCardBasketCount">
            {{ productCardBasketCount }}<i class="fa-regular fa-cart-shopping ms-2"></i>
        </div>

        <div v-if="product.clearancePrice && isPromoted">
            <img src="/img/special-offers/star_1.svg" class="promoted-star">
            <img src="/img/special-offers/drops_1.svg" class="promoted-drops">
        </div>

        <div class="product-section-first" :data-label="product.tag ? product.tag.name : null">
            <a v-on:click.prevent="setScrollPos($event)" :href="product.url">
                <img :src="product.main_image" loading  v-if="product.main_image" :alt="product.name" class="product-image">
                <img src="/img/keycraft-coming-soon-image-pink.png" loading  v-else :alt="product.name" class="product-image">
            </a>
        </div>
        <div class="product-section-middle">
            <h5><a v-on:click.prevent="setScrollPos($event)" :href="product.url">{{ product.name }}</a></h5>
            <div class="row">
                <div class="col flex-grow-1">
                    <p class="mb-0 small">{{ product.sku }}</p>
                    <p class="small list-view-pricing">
                  <span v-for="(price, key) in product.orderedPrices" :key="key">
                                        <span v-html="currency.symbol"></span>{{
                          price.price | currencyDecimals
                      }} <span v-text="__('vue.product-pricing.ea')"></span> /{{ price.quantity }}
                                        <span v-if="key !== (product.orderedPrices.length - 1)">
                                            <span v-text="__('vue.product-pricing.or') + ' '"></span>
                                        </span>
                                    </span>
                    </p>
                </div>
                <div :class="'col flex-grow-0 list-tag' + (product.clearancePrice ? ' clearance' : '')" v-if="product.tag || product.clearancePrice" :data-label="product.tag ? product.tag.name : (product.clearancePrice ? __('vue.product-pricing.clearance') : null)"></div>
            </div>


        </div>
        <div class="count-product-wishlist" v-bind:class="{ 'mt-3': activeList && productCardBasketCount }">
            <product-pricing
                :is-rep="isRep"
                :is-customer="isCustomer"
                :is-call-centre="isCallCentre"
                :user="user"
                :product="product"
                :is-wish-list-page="isWishListPage"
                :wishlist-direction="wishlistDirection"
                :is-product-details-page="isProductDetailsPage"
                :activeList="activeList"
                :activeGrid="activeGrid"
                @basketProductCountUpdated="basketProductCountUpdated"
                @deleteFromBasket="deleteFromBasket"
                @deleteFromWishList="deleteFromWishList"
                @productsBasketCountUpdated="productsBasketCountUpdated"
            />
        </div>
    </div>
</template>

<script>

export default {
    name: "ProductCard",
    props: {
        product: Object,
        isRep: Boolean,
        user: Object,
        locale: String,
        activeList: Boolean,
        activeGrid: Boolean,
        productsBasketCount: {
            default: null,
            type: Object|Array
        },
        isWishListPage: {
            default: false,
            type: Boolean
        },
        isBasketPage: {
            default: false,
            type: Boolean
        },
        isCallCentre: {
            default: false,
            type: Boolean
        },
        isCustomer: {
            default: false,
            type: Boolean
        },
        isProductDetailsPage: {
            default: false,
            type: Boolean
        },
        basketItem: {
            default: null,
            type: Object
        },
        wishlistDirection: {
            default: '',
            type: String
        },
        isPromoted: {
            default: false,
            type: Boolean
        }
    },
    data() {
        return {
            totals: null,
            currency: '',
            productCardBasketCount: null
        };
    },
    mounted() {
        if (this.user && this.user.customer && this.user.customer.currency) {
            this.currency = this.user.customer.currency;
            this.customerId = this.user.customer_id;
        }

        this.productCardBasketCount = this.productsBasketCount ? this.productsBasketCount[this.product.id] : null;
    },
    methods: {
        productsBasketCountUpdated(itemCount) {
            this.productCardBasketCount = itemCount[this.product.id];
            this.$emit('itemCountUpdated', itemCount);
        },
        showProductTag(product) {
            if (!product.tag) {
                return ''
            }

            return product.tag.name[this.locale]
        },
        basketProductCountUpdated(payload) {
            if (this.basketItem) {
                payload.basket_item_id = this.basketItem.id
            }
        },
        deleteFromBasket(payload) {
            this.$emit('deleteFromBasket', payload)
        },
        deleteFromWishList(payload) {
            this.$emit('deleteFromWishList', payload)
        },
        setScrollPos() {
            sessionStorage.setItem('product-list-scroll-marker', this.product.sku);
            window.location.href = this.product.url;
        }
    }
}
</script>
